const common = {
  no_data_title: 'No hay datos',
  no_data_description: 'No hay registros para mostrar.',
  loading: 'Cargando...',
  error: 'Ha ocurrido un error',
  success: 'Operación completada correctamente',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  save: 'Guardar',
  delete: 'Eliminar',
  edit: 'Editar',
  create: 'Crear',
  search: 'Buscar',
  filter: 'Filtrar',
  export: 'Exportar',
  help: 'Ayuda',
  export_empty: 'No hay datos que exportar con los filtros actuales',
  row_actions: 'Acciones',
  weekdays: {
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
  },
  filters: {
    label: 'Filtros',
    search: 'Buscar',
    show: 'Mostrar filtros',
    hide: 'Ocultar filtros',
  },
  nav: {
    // Rail entries that open onto several screens. A section with a single
    // visible screen borrows that screen's own name instead.
    sections: {
      calls: 'Llamadas',
      team: 'Equipo',
      clients: 'Clientes',
      settings: 'Configuración',
    },
  },
  menu: {
    // Short role hints shown as tooltips so the role model is obvious at a
    // glance: who answers calls vs who owns the account (roadmap #54).
    tooltips: {
      staff: 'Agentes que atienden las llamadas',
      clients: 'Titulares de la cuenta',
      orgManagers: 'Gestionan una organización',
    },
  },
  impersonation: {
    action: 'Suplantar identidad',
    active: 'Suplantando a %{name}',
    exit: 'Salir',
  },
  staffCaller: {
    button: 'Recibir llamadas',
  },
  clear: 'Limpiar',
  yes: 'Sí',
  no: 'No',
  status: {
    active: 'Activo',
    inactive: 'Inactivo',
    pending: 'Pendiente',
  },
  notifications: {
    session_extended_success: 'Sesión extendida correctamente',
    session_expired: 'Su sesión ha expirado. Por favor, inicie sesión de nuevo.',
    connection_error: 'Error de conexión. Por favor, compruebe su conexión a internet.',
    server_error: 'Error del servidor. Por favor, inténtelo de nuevo más tarde.',
    save_success: 'Datos guardados correctamente',
    save_error: 'Error al guardar los datos',
    delete_success: 'Elemento eliminado correctamente',
    delete_error: 'Error al eliminar el elemento',
  },
  validation: {
    required: 'Este campo es obligatorio',
    email: 'Por favor, introduzca un correo electrónico válido',
    minLength: 'Debe tener al menos %{min} caracteres',
    maxLength: 'No puede tener más de %{max} caracteres',
    number: 'Debe ser un número válido',
    positive: 'Debe ser un número positivo',
    unique: 'Este valor ya existe',
  },
};

export default common;
